import Image from 'next/image';
import { MainText, SubText, Wrapper } from './NoParcelsFoundPanel.styles';
import { useNoParcelsFoundPanelCopy } from './hooks';

export const NoParcelsFoundPanel: React.FC = () => {
  const { title, subtitle } = useNoParcelsFoundPanelCopy();

  return (
    <Wrapper>
      <Image
        src='/images/tracking-default-image.svg'
        alt='tracking-default-image'
        width={320}
        height={160}
        style={{
          objectFit: 'contain',
        }}
      />
      <MainText>{title}</MainText>
      <SubText>{subtitle}</SubText>
    </Wrapper>
  );
};
